export default __webpack_public_path__ + "static/media/revenue.9e42bf66.svg";